import { BuildingDetails } from '../models/buildingDetails.model';
import {
  BuildingActions,
  ADD_BUILDING_DETAILS,
  ADD_BUILDING_DETAILS_MANAGER,
  RETRIVE_DETAILS,
  UPDATE_BUILDING_UNITS,
  UPDATE_BUILDING_DETAILS,
  DELETE_BUILDING_DETAILS,
  BUILDING_RESET,
} from '../actions/building.actions';

const BUILDING_PRICE = 40;
let unit_number = 0;

export function buildingDetailsReducer(
  state: BuildingDetails[] = [],
  action: BuildingActions
) {
  switch (action.type) {
    case ADD_BUILDING_DETAILS:
      unit_number += 1;
      action.payload.monthly_price = BUILDING_PRICE;
      return [state.slice(), action.payload];

    case ADD_BUILDING_DETAILS_MANAGER:
      unit_number += 1;
      action.payload.unit_number = unit_number;
      action.payload.monthly_price = BUILDING_PRICE;
      return [action.payload];

    case RETRIVE_DETAILS:
      return [action.payload];

    case UPDATE_BUILDING_UNITS:
      return state.map((building) => {
        if (action.payload.address.buildingUnits > 0) {
          action.payload.monthly_price = BUILDING_PRICE;
          return building.unit_number === action.payload.unit_number
            ? { ...building, ...updateUnits(building) }
            : building;
        } else {
          return state.slice();
        }
      });

    case UPDATE_BUILDING_DETAILS:
      return state.map((building) => {
        return building.unit_number === action.payload.unit_number
          ? { ...building, ...action.payload.updatedBuilding }
          : building;
      });

    case DELETE_BUILDING_DETAILS:
      return state.filter((building) => building.unit_number !== action.payload.unit_number);

    case BUILDING_RESET:
      return action.payload.length === 0 ? [] : [];

    default:
      return state;
  }
}

function updateUnits(payload: any) {
  const UNITS = 40;
  let monthly_price = 20;
  if (payload.address.increment) {
    payload.address.buildingUnits = parseInt(payload.address.buildingUnits, 10) + 1;
  } else {
    payload.address.buildingUnits -= 1;
  }

  return payload;
}

